function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { ContextPanelEl } from "common/widgets/context-panel";
import { PositioningStrategy } from "../drop-menu/types";
import { DropMenuEl } from "../drop-menu";
import { SectionEl, SectionRowEl } from "./section";
import { SectionItemEl, SectionItemSubMenuEl } from "./section/item";
const EmptySearchResult = (_ref) => {
  let {
    message
  } = _ref;
  return /* @__PURE__ */ jsx("ul", { sel: ".screen-options-list", "data-sentry-component": "EmptySearchResult", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("li", { sel: ".list-option.list-empty" }, /* @__PURE__ */ jsx("div", { sel: ".option-label" }, message)));
};
const SectionList = (_ref2) => {
  let {
    comp,
    sections
  } = _ref2;
  const sectionsHint = comp.attr("sections-hint");
  const searchFilter = comp.attr("search-filter");
  const alignAllText = comp.attr("align-all-text") && sections.some((section) => section.iconRenderer || section.items.some((item) => {
    var _item$wrapped;
    return (_item$wrapped = item.wrapped) === null || _item$wrapped === void 0 ? void 0 : _item$wrapped.iconRenderer;
  }));
  const showMatches = !comp.attr("disable-search-filter-matching-parts");
  const {
    focusedItemIndex,
    isPillFocused,
    fullyShownSections
  } = comp.state;
  const {
    contextPanelTransform
  } = comp;
  const hasContextPanelContentSlot = comp.helpers.hasSlot("context-panel-content");
  let sectionsEl;
  if (sections.length) {
    sectionsEl = /* @__PURE__ */ jsx(null, null, sectionsHint && /* @__PURE__ */ jsx("div", { sel: ".sections-hint" }, sectionsHint), sections.map((section, idx) => {
      var _comp$state$sections$;
      return /* @__PURE__ */ jsx(null, null, idx > 0 && (!section.hideTopDivider || section.expansionToggle) && /* @__PURE__ */ jsx("div", { sel: ".section-divider", class: {
        "has-divider-line": !section.hideTopDivider
      } }), /* @__PURE__ */ jsx(SectionEl, { section, hideSectionTitle: section.isHidden && !fullyShownSections[section.sectionIndex] || Boolean(section.expansionToggle), areSectionItemsHidden: (section.isHidden || Boolean(section.expansionToggle)) && !fullyShownSections[section.sectionIndex], numOriginalItems: ((_comp$state$sections$ = comp.state.sections[section.sectionIndex]) === null || _comp$state$sections$ === void 0 ? void 0 : _comp$state$sections$.items.length) || 0, i18n: comp.getContext("i18n") }, section.items.map((item) => {
        var _sectionItem$actionsR, _sectionItem$iconRend;
        const sectionItem = item.wrapped;
        const isFocused = focusedItemIndex === item.index;
        const isItemSubMenuOpen = comp.isSubItemsOpen(item.index);
        const selectedTheme = section.selectedTheme && comp.getSelectedTheme(section.selectedTheme) || comp.getSelectedTheme();
        return /* @__PURE__ */ jsx(SectionRowEl, { allowPointerEventsAlways: hasContextPanelContentSlot, item, isFocused, selectedTheme, contextPanelTransform, onClick: comp.helpers.handleClickItem, onMouseEnter: comp.helpers.handleMouseEnterItem }, /* @__PURE__ */ jsx(SectionItemEl, { item, isPillFocused, selectedTheme, isFocused, alignAllText, showMatches, actionsRenderer: (_sectionItem$actionsR = sectionItem.actionsRenderer) !== null && _sectionItem$actionsR !== void 0 ? _sectionItem$actionsR : section.actionsRenderer, iconRenderer: (_sectionItem$iconRend = sectionItem.iconRenderer) !== null && _sectionItem$iconRend !== void 0 ? _sectionItem$iconRend : section.iconRenderer, onActionClick: comp.helpers.handleClickPill, onActionMouseEnter: comp.helpers.handleMouseEnterPill, onActionMouseLeave: comp.helpers.handleMouseLeavePill, fullyShownSections: comp.state.fullyShownSections, i18n: comp.getContext("i18n") }), isItemSubMenuOpen && (sectionItem.subMenuRenderer ? sectionItem.subMenuRenderer((selectedValue, additionalInfo) => {
          const itemClickEvent = comp.getClickItemEvent({
            item: _objectSpread(_objectSpread({}, item), {}, {
              wrapped: _objectSpread(_objectSpread({}, item.wrapped), {}, {
                value: selectedValue,
                additionalInfo
              })
            }),
            modifierKeys: null
          });
          comp.helpers.handleSubItemsClickItem(itemClickEvent);
        }, comp) : /* @__PURE__ */ jsx(SectionItemSubMenuEl, { sections: sectionItem.subSections, alignAllText: comp.attr("align-all-text"), selectedTheme, contextPanelTransform, keydownProxyEl: comp.keydownProxyEl || comp, onNavigateBack: comp.helpers.handleSubItemsNavigateBack, onClickItem: comp.helpers.handleSubItemsClickItem, onFocusItem: comp.helpers.propagateEvent, onMouseEnter: comp.helpers.handleSubMenuMouseEnter })));
      })));
    }));
  }
  let emptyMessageEl;
  if (comp.getFilledSections(sections, {
    excludeAlwaysShowLabel: true
  }).length === 0) {
    if (searchFilter) {
      emptyMessageEl = /* @__PURE__ */ jsx(EmptySearchResult, { message: comp.attr("empty-search-results-message") });
    } else {
      emptyMessageEl = /* @__PURE__ */ jsx(EmptySearchResult, { message: comp.attr("empty-message") });
    }
  }
  return /* @__PURE__ */ jsx(null, null, sectionsEl, emptyMessageEl);
};
export function template() {
  const {
    tooltipData
  } = this.state;
  const hasContextPanelContentSlot = this.helpers.hasSlot("context-panel-content");
  const sections = this.helpers.getDisplaySections();
  return /* @__PURE__ */ jsx("div", { sel: ".items-menu", hook: {
    postpatch: this.helpers.handlePostPatch
  }, class: {
    ["".concat(this.attr("theme"), "-theme")]: true,
    ["".concat(this.attr("size"), "-size")]: true,
    "disable-first-item-padding": this.attr("disable-first-item-padding")
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".screen-list-container", class: {
    "has-sections": sections.length > 0
  }, on: {
    scroll: this.helpers.handleScroll,
    mouseleave: () => this.helpers.handleMouseLeave(),
    mouseenter: () => this.debouncedUnFocusItem.cancel()
  }, hook: {
    insert: (_ref3) => {
      let {
        elm
      } = _ref3;
      return this.handleInsertScreenListContainer(elm);
    }
  } }, /* @__PURE__ */ jsx(SectionList, { comp: this, sections, "data-sentry-element": "SectionList", "data-sentry-source-file": "template.tsx" })), tooltipData && /* @__PURE__ */ jsx(ContextPanelEl, { attrs: {
    elref: "contextPanel",
    placement: this.attr("context-panel-alignment"),
    "project-is-free-plan": this.attr("project-is-free-plan")
  }, params: {
    data: tooltipData,
    positionParent: this.contextPanelPositionParentElement
  } }), hasContextPanelContentSlot && /* @__PURE__ */ jsx(DropMenuEl, { attrs: {
    direction: this.attr("context-panel-alignment"),
    offset: -8,
    skidding: 72,
    open: true,
    "position-strategy": PositioningStrategy.Absolute
  }, props: {
    positionParent: this.contextPanelPositionParentElement
  } }, /* @__PURE__ */ jsx("slot", { attrs: {
    name: "context-panel-content"
  } })));
}
